import React, { FC } from 'react';
import { CircularProgress, Dialog, Grid, Typography } from '@mui/material';
import Button from 'components/Button';
import { useLanguage } from 'context/AppContext';
import { ModalContent } from 'pages/DeliveryPortal/DeliveryPortalPage.styles';
import * as Styles from './ProceedWithCreateDraftsModal.styles';

interface ProceedWithCreateDraftsModalProps {
  open: boolean;
  close: () => void;
  handleProceed: Function;
  isLoading: boolean;
}

export type ModalContentType = 'selectItem' | 'selectTray' | 'selectPart' | 'selectSerialNumbers';

const ProceedWithCreateDraftsModal: FC<ProceedWithCreateDraftsModalProps> = ({
  open,
  close,
  handleProceed,
  isLoading,
}) => {
  const [language] = useLanguage();
  const handleClose = (): void => {
    close();
  };

  return (
    <Dialog open={open} maxWidth="xs" fullWidth onClose={handleClose}>
      <ModalContent>
        {isLoading ? (
          <Styles.Container>
            <CircularProgress />
          </Styles.Container>
        ) : (
          <>
            <Styles.BoxStyled>
              <Typography variant="h5">
                <Styles.TitleContainer>
                  <Styles.ErrorOutlineIconStyled />
                  <Styles.ModalTitle>
                    {language.DataUpload.proceedWithCreateDraftsModal.proceedWithUpload}
                  </Styles.ModalTitle>
                </Styles.TitleContainer>
                <Styles.TypographyStyled variant="subtitle1">
                  {language.DataUpload.proceedWithCreateDraftsModal.yes}
                </Styles.TypographyStyled>
              </Typography>
            </Styles.BoxStyled>
            <Grid container justifyContent="space-between">
              <Button onClick={() => handleClose()}>{language.DataUpload.proceedWithCreateDraftsModal.goBack}</Button>
              <Button onClick={() => handleProceed()}>
                {language.DataUpload.proceedWithCreateDraftsModal.proceed}
              </Button>
            </Grid>
          </>
        )}
      </ModalContent>
    </Dialog>
  );
};

export default ProceedWithCreateDraftsModal;
